import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const RefreshProductFeedsRequest = z.record(z.string(), z.never())

export type RefreshProductFeedsRequest = z.infer<typeof RefreshProductFeedsRequest>

export const RefreshProductFeedsResponse = z.object({
  itemCount: z.number(),
})

export type RefreshProductFeedsResponse = z.infer<typeof RefreshProductFeedsResponse>

export const refreshProductFeedsDeclaration = endpointDeclaration(
  RefreshProductFeedsRequest,
  RefreshProductFeedsResponse,
)
